import StockControl from "./StockControl";
export default function StockControlRoute() {
  return <StockControl />;
}
